module.exports = __webpack_public_path__ + "static/media/E601.a8af9ea0.png";